// extracted by mini-css-extract-plugin
export default {"cta":"HG-z","disabled":"IG-z"};